module.exports = __webpack_public_path__ + "img/40_38_063_820.156f17da.jpg";